import { forwardRef, type ReactNode, type Ref } from 'react';
import { Box, type BoxProps } from '../Box/Box.js';
import { resolveSpacing } from '../../theme/index.js';
import './Stack.css';

export interface StackProps extends BoxProps {
  gap?: 'xxs' | 'xs' | 'sm' | 'md' | 'lg' | 'xl' | 'xxl' | 'xxxl' | number | string;
  align?: 'stretch' | 'start' | 'center' | 'end' | 'flex-start' | 'flex-end';
  justify?: 'flex-start' | 'flex-end' | 'center' | 'space-between' | 'space-around' | 'space-evenly';
}

/** Vertical layout: flex column with a configurable gap. */
export const Stack = forwardRef(function Stack(
  { gap = 'md', align, justify, style, children, ...rest }: StackProps,
  ref: Ref<HTMLElement>
): ReactNode {
  return (
    <Box
      ref={ref}
      {...rest}
      className={['rr-stack', rest.className].filter(Boolean).join(' ')}
      style={{
        ...style,
        gap: resolveSpacing(gap),
        alignItems: align,
        justifyContent: justify
      }}
    >
      {children}
    </Box>
  );
});
